import React from 'react'
import { Link } from 'react-router-dom'

import { DeemphasizedLink, MembershipTypeLabel, Text } from '@fielded/shared-ui'
import { ArrowRightLeft } from '@fielded/shared-ui/src/icons'

const ImpersonationBanner = () => {
  // TODO: replace with real data from impersonated user
  const membershipType = 'basic'
  const userName = 'Barnawa Meds'
  return (
    <div className='impersonation-banner'>
      <div className='vs-u-row-spaced'>
        <Text bold className='vs-u-row vs-u-gap'>
          <MembershipTypeLabel
            membershipType={membershipType}
            size='small'
            iconOnly
            isOnAccentColor
          />
          {userName}
        </Text>
        <DeemphasizedLink
          icon={<ArrowRightLeft />}
          size='small'
          bold
          component={Link}
          to={'/'}
        >
          Switch client
        </DeemphasizedLink>
      </div>
      {/* <div>
        TODO: Add wallet component here
      </div> */}
    </div>
  )
}

export default ImpersonationBanner
